module.exports = __webpack_public_path__ + "static/media/Accademia - White - 8932_865_8376.5cb72960.jpg";